import styled, { css } from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

interface CellProps {
  noPadding?: boolean
  altCell?: boolean
}

interface RowProps {
  isExpanded?: boolean
}

export const PolicyDataContainer = styled.div`
  width: 100%;
  max-width: 1040px;
  padding-left: 50px;
  padding-right: 50px;
`

export const GeralDataContainer = styled.div`
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 40px;
  margin-bottom: 40px;
  align-items: center;

  @media ${BREAKPOINTS.lg} {
    padding-left: 40px;
    padding-right: 40px;
  }

  > .row {
    width: 100%;
    max-width: calc(100% - 32px);
    display: flex;
    gap: 32px;
    margin: auto;

    @media ${BREAKPOINTS.lg} {
      gap: 44px;
    }

    > .col {
      width: 50%;

      > div,
      .DFdatePicker,
      .DFtextField,
      .DFnumberField {
        margin-top: 0;
      }
    }
  }
`

export const GeralData = styled.div`
  .button-create {
    > div {
      margin-left: auto;
    }
  }
`

export const Cell = styled.td<CellProps>`
  padding: 0 0 0 20px;
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  letter-spacing: 0.02em;
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;

  .DFpagination {
    border-bottom: 2px solid rgb(18, 163, 187);
    padding: 0;
    margin: 0;
    max-width: 100%;

    li {
      display: none;
    }
  }

  ${({ noPadding }: Pick<CellProps, 'noPadding'>) =>
    noPadding &&
    css`
      padding: 0;
    `}

  ${({ altCell }: Pick<CellProps, 'altCell'>) =>
    altCell &&
    css`
      font-size: 18px;
      padding-top: 8;
      padding-bottom: 8;
    `}
`

export const Row = styled.tr<RowProps>`
  border-bottom: ${({ isExpanded }: RowProps) =>
    isExpanded ? 'none' : '1px solid #f6f6f6'};
`

export const RowNoPadding = styled(Row)`
  padding: 10px 0;
  margin: 0;
`

export const CellNoPadding = styled(Cell)`
  padding: 0px 0;
  margin: 0;
`

export const RowWithourBorder = styled.tr`
  border-style: solid;
  border-width: 0 0 0 0;
`

export const NamePackPrice = styled.div`
  font-family: Ubuntu;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #1f1f1f;
`

export const ChosenPack = styled.div`
  font-family: Ubuntu;
  font-size: 8px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #1f1f1f;
`

export const ActionsCell = styled(Cell)`
  width: 70px;
  text-align: end;
  padding: 8px;
  font-weight: 700;
  justify-content: right;
`

export const Actions = styled.div`
  display: flex;
  justify-content: right;
  margin-right: 20px;
  gap: 10px;
`

export const ButtonContainer = styled.span`
  display: flex;
  padding: 2px;
  justify-content: right;
`

export const AnimalBreedContainer = styled.span`
  display: flex;
  padding: 0px;
  justify-content: left;
`

export const DeleteButton = styled.img`
  cursor: pointer;
`

export const OpenCollapseButton = styled.img`
  cursor: pointer;
`

export const RadioButtonContainer = styled.div`
  .DFradioFieldWrapper {
    span {
      > div {
        display: flex;
      }
    }
  }
  .DFradioField {
    label {
      text-align: left;
    }
  }
`

export const RadioSectionContainer = styled.div`
  padding: 20px;
  margin: 30px 40px 20px 40px;
  border-style: solid;
  border-width: 2px;
  border-color: #f6f6f6;
`

export const QuestionaryContainer = styled.div`
  width: 100%;
`

export const Title = styled.h1`
  margin-bottom: 20px;
  padding-left: 20px;
  font-family: Ubuntu, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: #0093b2;
  text-align: left;
`
